import * as THREE from 'three';

export class TerrainMaterial {
    /**
     * 높이에 따른 색상 반환
     * @param {number} height - 정규화된 높이 (0~1)
     * @returns {THREE.Color} 색상
     */
    static getColorByHeight(height: number): THREE.Color {
        // 색상 정의
        const colors = {
            deepWater: new THREE.Color(0x1e3a5f),  // 깊은 물
            water: new THREE.Color(0x2e5f8c),      // 물
            sand: new THREE.Color(0xc2b280),       // 모래
            grass: new THREE.Color(0x4a7c38),      // 풀
            rock: new THREE.Color(0x8b8680),       // 바위
            snow: new THREE.Color(0xffffff)        // 눈
        };

        // 높이 임계값
        const thresholds = {
            deepWater: 0.2,
            water: 0.3,
            sand: 0.4,
            grass: 0.7,
            rock: 0.9
        };

        let color = new THREE.Color();

        if (height < thresholds.deepWater) {
            // 깊은 물
            color = colors.deepWater;
        } else if (height < thresholds.water) {
            // 물
            const t = (height - thresholds.deepWater) /
                (thresholds.water - thresholds.deepWater);
            color.lerpColors(colors.deepWater, colors.water, t);
        } else if (height < thresholds.sand) {
            // 물 → 모래 전환
            const t = (height - thresholds.water) /
                (thresholds.sand - thresholds.water);
            color.lerpColors(colors.water, colors.sand, t);
        } else if (height < thresholds.grass) {
            // 모래 → 풀 전환
            const t = (height - thresholds.sand) /
                (thresholds.grass - thresholds.sand);
            color.lerpColors(colors.sand, colors.grass, t);
        } else if (height < thresholds.rock) {
            // 풀 → 바위 전환
            const t = (height - thresholds.grass) /
                (thresholds.rock - thresholds.grass);
            color.lerpColors(colors.grass, colors.rock, t);
        } else {
            // 바위 → 눈 전환
            const t = (height - thresholds.rock) / (1.0 - thresholds.rock);
            color.lerpColors(colors.rock, colors.snow, t);
        }

        return color;
    }

    /**
     * 머티리얼 생성
     * @param {boolean} useVertexColors - 버텍스 컬러 사용 여부
     * @returns {THREE.Material}
     */
    static createMaterial(useVertexColors: boolean = true): THREE.Material {
        if (useVertexColors) {
            return new THREE.MeshStandardMaterial({
                vertexColors: true,  // 버텍스 컬러 활성화
                flatShading: false,
                side: THREE.DoubleSide
            });
        } else {
            return new THREE.MeshStandardMaterial({
                color: 0x4a7c38,
                flatShading: false,
                side: THREE.DoubleSide
            });
        }
    }
}
